import { createContext, useContext, useEffect } from 'react'
import { useThemeStore } from '@/stores/useThemeStore'

const ThemeContext = createContext()

export function ThemeProvider({ children }) {
  const { theme, toggleTheme, setTheme } = useThemeStore()

  useEffect(() => {
    // Initialize theme on mount
    const root = document.documentElement
    root.classList.remove('light', 'dark')
    root.classList.add(theme)
  }, [theme])

  const value = {
    theme,
    toggleTheme,
    setTheme,
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}